import React from 'react'

const Table = ({ data }) => {
    return (
        <table className="table-auto lg:w-[600px]">
            <thead>
                <tr>
                    <th className="px-4 py-2 border border-blue-950">{data[0].column1Title}</th>
                    <th className="px-4 py-2 border border-blue-950">{data[0].column2Title}</th>
                </tr>
            </thead>
            <tbody>
                {data.slice(1).map((row, index) => (
                    <tr key={index}>
                        <td className="border px-4 py-2 border-blue-950">{row.column1}</td>
                        <td className="border px-4 py-2 border-blue-950">{row.column2}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
}

export default Table